import {get} from '../utils'

export default host => (id, tags) =>
  get(`${host}/clients/${id}/voices?tags_ids=${tags.join(',')}&include=audio&order_by=updated_at&sort_type=DESC`)
    .then(response => response.json())
    .then(json => json.data)
